export default __webpack_public_path__ + "static/media/text-field-helper-text.136d13fb.svg";